import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "marker",
  "use": "marker-usage",
  "viewBox": "0 0 65.32 85",
  "content": "<symbol viewBox=\"0 0 65.32 85\" id=\"marker\"><title>资源 109</title><g id=\"marker_图层_2\" data-name=\"图层 2\"><g id=\"marker_图层_1-2\" data-name=\"图层 1\"><path d=\"M32.66,85c-1,0-1.58-.12-1.93-.54-.21-.25-21.8-25.87-27.55-38.28A33.24,33.24,0,0,1,0,32.2C0,14.44,14.65,0,32.66,0A32.57,32.57,0,0,1,65.32,32.41a27.46,27.46,0,0,1-3.49,14.08C55,59.2,34.82,84.16,34.62,84.41S34,85,32.71,85h-.05Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/marker.svg
// module id = LLbh
// module chunks = 264